import { Dialog } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

import { UserBehaviorAnalyticsService } from '~features/user-behavior-analytics/user-behavior-analytics.service';
import { ResponsiveVideoComponent } from '~features/video/responsive-video/responsive-video.component';
import { VideoDialogComponent } from '~features/video/video-dialog/video-dialog.component';
import { DialogService } from '~shared/services/dialog.service';
import { PosthogService } from '~shared/services/posthog.service';

@Component({
  selector: 'app-video-player',
  imports: [ResponsiveVideoComponent, NgClass],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.css',
})
export class VideoPlayerComponent {
  @Input() videoURL = '';
  @Input() openInDialog = false;
  @Input() redirectToURL = false;

  dialogService = inject(DialogService);
  posthogService = inject(PosthogService);
  ubaService = inject(UserBehaviorAnalyticsService);
  constructor(private dialog: Dialog) {}

  handleClick() {
    this.posthogService.trackVideoClicked(this.videoURL);
    if (this.openInDialog) {
      this.openVideoDialog();
    }
    this.ubaService.trackButtonClick(
      'play-video',
      null,
      {
        videoURL: this.videoURL,
      },
      window.location.href
    );
  }

  private openVideoDialog() {
    this.dialogService.open(VideoDialogComponent, {
      maxWidth: '80%',
      data: { videoURL: this.videoURL },
    });
  }
}
